/**
 * Expense summary — `GET expenses/summary/`, a BARE ARRAY of `{category,
 * total}` grouped totals (expenses/routes.ts:143-163), not the pagination
 * envelope every other list page in this app reads. `total` is a raw JSON
 * number here, unlike the quantised decimal strings `ExpenseListPage` renders.
 */
import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { parseApiError } from '../../lib/apiError';
import { getExpenseSummary } from '../../api/endpoints/expenses';

export function ExpenseSummaryPage(): React.JSX.Element {
  const query = useQuery({
    queryKey: ['expense-summary'],
    queryFn: () => getExpenseSummary(),
  });

  const rows = query.data ?? [];
  const grandTotal = rows.reduce((sum, row) => sum + row.total, 0);

  return (
    <section>
      <h2>Expense summary</h2>

      <p>
        <Link to="..">Back to expenses</Link>
      </p>

      {query.isPending && <p>Loading…</p>}
      {query.isError && (
        <p role="alert" className="form__error">
          {parseApiError(query.error).message}
        </p>
      )}

      {query.isSuccess && rows.length === 0 && <p>No expenses found.</p>}

      {query.isSuccess && rows.length > 0 && (
        <table>
          <thead>
            <tr>
              <th>Category</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.category}>
                <td>{row.category}</td>
                <td>{row.total.toFixed(2)}</td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr>
              <td>Grand total</td>
              <td>{grandTotal.toFixed(2)}</td>
            </tr>
          </tfoot>
        </table>
      )}
    </section>
  );
}

export default ExpenseSummaryPage;
